export enum TreeOfLifeLocations {
	'Hotel',
	'Pond',
	'Forest'
}
